import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Linkedin, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div className="space-y-6">
            <h3 className="text-2xl font-bold text-gray-900">
              ARCHSTUDIO
            </h3>
            <p className="text-gray-600 text-base leading-relaxed">
              Creating innovative architectural solutions for commercial, corporate, institutional, and transportation projects.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-6 text-sm uppercase tracking-wider text-gray-900">Navigate</h4>
            <ul className="space-y-4">
              <li>
                <Link to="/" className="text-gray-600 hover:text-gray-900 transition-colors text-base">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/projects" className="text-gray-600 hover:text-gray-900 transition-colors text-base">
                  Work
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-600 hover:text-gray-900 transition-colors text-base">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-600 hover:text-gray-900 transition-colors text-base">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold mb-6 text-sm uppercase tracking-wider text-gray-900">Get in Touch</h4>
            <ul className="space-y-4 text-base">
              <li className="flex items-start gap-3 text-gray-600">
                <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <span>123 Architecture Lane<br />New York, NY 10001</span>
              </li>
              <li className="flex items-center gap-3 text-gray-600">
                <Mail className="w-5 h-5 flex-shrink-0" />
                <span>hello@archstudio.com</span>
              </li>
            </ul>

            {/* Social Links */}
            <div className="flex gap-4 mt-8">
              <a
                href="#"
                className="text-gray-600 hover:text-gray-900 transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="text-gray-600 hover:text-gray-900 transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 pt-8 text-sm text-gray-600">
          <p>&copy; {new Date().getFullYear()} ArchStudio. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;